/* eslint-disable no-console */
import makeAPIRequest from "../../services/makeRequest";
import config from "./../../config";

async function submitLogin(payload) {
  const API_ENDPOINT = `${config["API_BASE_ENDPOINT"]}/admin/login`;

  const response = await makeAPIRequest(API_ENDPOINT, "POST", payload);
  const jsonResponse = await response.json();
  return jsonResponse;
}

export default submitLogin;
